// extracted by mini-css-extract-plugin
module.exports = {"rippleOff":"focus_rippleOff__IM80q","rippleSelect":"focus_rippleSelect__fD_Ir","ripple":"focus_ripple__TZcTA","rippleSbmt":"focus_rippleSbmt__EoTgF"};